import CommentControl from './CommentControl';
import CommentControlContainer from './CommentControl.container';
export default CommentControlContainer(CommentControl);

//# sourceMappingURL=index.js.map